import React from "react";
import {AbsoluteFill, Sequence} from "remotion";
import {AnimatedTitle} from "../../components/text/AnimatedTitle";
import {GradientBackground} from "../../components/backgrounds/GradientBackground";
import {ParticleField} from "../../components/backgrounds/ParticleField";
import {CallToAction} from "../../components/overlays/CallToAction";
import {SafeArea} from "../../components/layout/SafeArea";
import {Watermark} from "../../components/overlays/Watermark";
import {loadDefaultFonts} from "../../presets/fonts";
import {BRAND} from "../../presets/brand";
import {OrganicLayer} from "../../components/overlays/OrganicLayer";
import {FilmGrain as CinemaGrain, CinemaVignette} from "../../components/overlays/FilmGrain";

export interface AnnouncementProps {
  preTitle?: string;
  title?: string;
  subtitle?: string;
  cta?: string;
  ctaSubtext?: string;
  backgroundColors?: string[];
  accentColor?: string;
}

export const Announcement: React.FC<AnnouncementProps> = ({
  preTitle = "Introducing",
  title = "Your Title Here",
  subtitle,
  cta,
  ctaSubtext,
  backgroundColors = ["#0f0f23", "#1a1a3e"],
  accentColor = "#6366f1",
}) => {
  loadDefaultFonts();

  return (
    <OrganicLayer intensity="subtle" seed="announcement">
    <AbsoluteFill>
      <GradientBackground colors={backgroundColors} angle={135} animateAngle animateSpeed={0.3} />
      <ParticleField count={40} color={`${accentColor}30`} speed={0.3} />

      <SafeArea>
        <AbsoluteFill style={{justifyContent: "center", alignItems: "center"}}>
          {/* Pre-title */}
          {preTitle && (
            <Sequence from={0} durationInFrames={200}>
              <div style={{position: "absolute", top: "30%", width: "100%", textAlign: "center"}}>
                <AnimatedTitle
                  text={preTitle}
                  fontSize={24}
                  fontWeight={500}
                  color={accentColor}
                  enterAnimation="fade"
                  enterDuration={20}
                  holdDuration={140}
                  exitDuration={15}
                  letterSpacing={6}
                />
              </div>
            </Sequence>
          )}

          {/* Main title */}
          <Sequence from={20} durationInFrames={220}>
            <AbsoluteFill style={{justifyContent: "center", alignItems: "center"}}>
              <AnimatedTitle
                text={title}
                fontSize={72}
                fontWeight={900}
                color="#ffffff"
                enterAnimation="scale"
                exitAnimation="blur"
                enterDuration={25}
                holdDuration={150}
                exitDuration={20}
                textShadow={`0 0 40px ${accentColor}40`}
              />
            </AbsoluteFill>
          </Sequence>

          {/* Subtitle */}
          {subtitle && (
            <Sequence from={50} durationInFrames={190}>
              <div style={{position: "absolute", top: "58%", width: "100%", textAlign: "center"}}>
                <AnimatedTitle
                  text={subtitle}
                  fontSize={28}
                  fontWeight={400}
                  color="rgba(255,255,255,0.7)"
                  enterAnimation="slideUp"
                  exitAnimation="fade"
                  enterDuration={20}
                  holdDuration={130}
                  exitDuration={15}
                />
              </div>
            </Sequence>
          )}
        </AbsoluteFill>
      </SafeArea>

      {/* CTA */}
      {cta && (
        <Sequence from={80}>
          <CallToAction
            text={cta}
            subtext={ctaSubtext}
            backgroundColor={accentColor}
            enterDelay={0}
          />
        </Sequence>
      )}

      <Watermark text={BRAND.handle} corner="topRight" opacity={0.5} fontSize={14} color="#ffffff" margin={40} />
      <CinemaGrain opacity={0.06} />
      <CinemaVignette opacity={0.5} />
    </AbsoluteFill>
    </OrganicLayer>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
